import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService, UtilsService } from 'src/app/services';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ProductTaskDesignLink } from 'src/app/models/product_task_design_link.model';
import { MatInputModule } from '@angular/material/input';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ProductTaskDesignLinkDetailDialogComponent } from './product-task-design-link-detail-dialog/product-task-design-link-detail-dialog.component';

@Component({
  selector: 'app-product-task-design-links-crud-dialog',
  imports: [MatIconModule, MatDialogModule, MatTableModule, MatButtonModule, MatInputModule],
  templateUrl: './product-task-design-links-crud-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-task-design-links-crud-dialog.component.css',
})
export class ProductTaskDesignLinksCrudDialog implements OnInit {
  dialogRef = inject<MatDialogRef<ProductTaskDesignLinksCrudDialog>>(MatDialogRef);
  protected utils = inject(UtilsService);
  private api = inject(ApiService);
  protected activatedRoute = inject(ActivatedRoute);
  protected fb = inject(UntypedFormBuilder);
  protected router = inject(Router);
  private dialog = inject(MatDialog);
  private permissions = inject(PermissionsService);
  data = inject<{
    company_product_id: number;
    product_task_id: number;
    product_task_design_links: ProductTaskDesignLink[];
  }>(MAT_DIALOG_DATA);

  displayedColumns: string[] = [
    'link',
    'comment',
    // 'actions',
  ];

  dataSource: MatTableDataSource<ProductTaskDesignLink>;
  companyProductId: number;
  productTaskId: number;
  canEditDesignLinks: boolean = false;

  constructor() {
    const data = this.data;

    this.companyProductId = data.company_product_id;
    this.productTaskId = data.product_task_id;
    this.dataSource = new MatTableDataSource<ProductTaskDesignLink>(data.product_task_design_links);
  }

  ngOnInit(): void {
    this.checkUserPermissions();
    this.initColumns();

    this.dialogRef.backdropClick().subscribe(() => {
      this.dialogRef.close(this.dataSource.data);
    });
  }

  openCreateTaskDesignLinkDialog(): void {
    const dialogRef = this.dialog.open(ProductTaskDesignLinkDetailDialogComponent, {
      width: '400px',
      data: {
        product_task_id: this.productTaskId,
      },
    });

    dialogRef.afterClosed().subscribe((data: ProductTaskDesignLink | undefined) => {
      if (data) {
        this.dataSource.data = [data, ...this.dataSource.data];
      }
    });
  }

  openEditTaskDesignLinkDialog(record: ProductTaskDesignLink): void {
    const dialogRef = this.dialog.open(ProductTaskDesignLinkDetailDialogComponent, {
      width: '400px',
      data: {
        product_task_id: this.productTaskId,
        product_task_design_link_id: record.id,
      },
    });

    dialogRef.afterClosed().subscribe((data: ProductTaskDesignLink | undefined) => {
      if (data) {
        const index = this.dataSource.data.findIndex(item => item.id === data.id);
        if (index !== -1) {
          const updatedData = [...this.dataSource.data];
          updatedData[index] = data;
          this.dataSource.data = updatedData;
        }
      }
    });
  }

  openDeleteTaskDesignLinkDialog(record: ProductTaskDesignLink): void {
    if (!confirm('¿Seguro que quieres eliminar el enlace?')) {
      return;
    }

    this.api.deleteProductTaskDesignLink(record).subscribe(() => {
      const index = this.dataSource.data.findIndex(item => item.id === record.id);
      if (index !== -1) {
        const updatedData = [...this.dataSource.data];
        updatedData.splice(index, 1);
        this.dataSource.data = updatedData;
      }
    });
  }

  private checkUserPermissions(): void {
    const isProductDesigner = this.permissions.isBisualProductionTeamInCompanyProductWithRole(
      this.companyProductId.toString(),
      'product-designer'
    );
    const isProductManager = this.permissions.isBisualProductionTeamInCompanyProductWithRole(
      this.companyProductId.toString(),
      'product-manager'
    );
    const isTechLead = this.permissions.isBisualProductionTeamInCompanyProductWithRole(this.companyProductId.toString(), 'tech-lead');

    this.canEditDesignLinks = isProductDesigner || isProductManager || isTechLead;
  }

  private initColumns() {
    if (this.canEditDesignLinks) {
      this.displayedColumns.push('actions');
    }
  }
}
